import {createCanBoundTo} from "@casl/react";
import ability from '../Ability';

export default createCanBoundTo(ability)